// extracted by mini-css-extract-plugin
export default {"title":"Applications_title__996YU","tableContainer":"Applications_tableContainer__TEH3s","tableContainerDealer":"Applications_tableContainerDealer__N-kQz"};